<script setup lang="ts">
import { PhArrowRight } from '@phosphor-icons/vue'

import { classMerge } from '../utils'

withDefaults(defineProps<{
  twClass?: string;
  baseurl: string;
  currentPage: number;
  numPages: number;
}>(), {
  twClass: '',
  baseurl: '',
  currentPage: 1,
  numPages: 2
})

const ghost = `text-action-ghost-foreground rounded-action-ghost hover:text-action-ghost-hover-foreground
               focus:text-action-ghost-hover-foreground focus-visible:outline-none focus-visible:ring
               focus-visible:ring-offset-1 ring-ring`

</script>

<template>
  <a class="inline-flex justify-center items-center w-8 h-8 md:w-11 md:h-11 p-0 text-button-md font-button"
     :class="classMerge([ghost, {'opacity-50 pointer-events-none': currentPage === numPages}, twClass])"
     :href="currentPage === numPages ? undefined : `${baseurl}?page=${currentPage + 1}`">
    <PhArrowRight weight="bold"
                  class="h-4 w-4 md:h-5 md:w-5" />
  </a>
</template>
